import React from 'react';
import { itemFilterTypes } from '../../../constants';
import FilterGroup from './filter-group';

const EventFilterGroup = ({ onApply }) => {
  const activeFilters = [
    itemFilterTypes.cpdCategory,
    itemFilterTypes.eventDuration,
    itemFilterTypes.location,
    itemFilterTypes.goal
  ]

  return <span id='event-filter-group'>
    <FilterGroup {...{
      activeFilters,
      onApply
    }} />
  </span>
}

export default EventFilterGroup


// WEBPACK FOOTER //
// ./src/containers/components/filters/event-filter-group.js